// Subscript characters that are not supported Roboto font
export const UNSUPPORTED_SUBSCRIPT_CHARACTERS = new Set<string>([
  'ₐ',
  'ₑ',
  'ₕ',
  'ᵢ',
  'ⱼ',
  'ₖ',
  'ₗ',
  'ₘ',
  'ₙ',
  'ₒ',
  'ₚ',
  'ᵣ',
  'ₛ',
  'ₜ',
  'ᵤ',
  'ᵥ',
  'ₓ',
]);
